import React from 'react';
import { Box } from '@mui/material';

const AdminLayout = ({ children }) => {
  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        p: 1,
        marginTop: '64px', // גובה ה-AppBar
        transition: 'opacity 0.3s ease',
        overflowX: 'auto',
      }}
    >
      {children}
    </Box>
  );
};

export default AdminLayout;
